import { getMessages } from '../../../../../../../store/constants';

export const COLOR_LABEL = getMessages().getText('card_form_select_color');
export const COLOR_BOARD = getMessages().getText('card_form_color_board');
export const COLOR_ALL = getMessages().getText('card_form_color_all');
export const COLOR_MODAL_CANCEL = getMessages().getText('common.cancel');
export const COLOR_MODAL_REMOVE = getMessages().getText('common.remove');
export const COLOR_MODAL_TITLE_CARD = getMessages().getText('card_form_color_modal_title.card');
export const COLOR_MODAL_TITLE_LIST = getMessages().getText('card_form_color_modal_title.list');
